import * as actionTypes from 'modules/auditModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {import('modules/global/generic.types.js').Page} */
const initialState = {
  number: 0,
  totalElements: 0,
  totalPages: 0,
  size: 10,
};

/**
 * @param {import('modules/global/generic.types.js').Page} _
 * @param {import('modules/global/generic.types').Action<import('modules/global/generic.types').PageContent<any>>} action
 */
const afterFetch = (_, { payload }) => payload.page;

const reset = () => initialState;

export default createReducer(initialState, {
  [actionTypes.FETCH_AUDIT_MODELS_MY_SUCCESS]: afterFetch,
  [actionTypes.FETCH_AUDIT_MODELS_MY_FAILURE]: reset,
});
